import React, {
  memo,
  useImperativeHandle,
  useRef,
  useEffect,
  useState,
} from 'react';
import { connect, useSelector } from 'react-redux';
import useTheme from '@hooks/useTheme';
import {
  Form,
  Input,
  Row,
  Col,
  Button,
  Checkbox,
  Select,
  Spin,
  Switch,
  DatePicker,
  Tooltip,
  Radio,
} from 'antd';
import moment from 'moment';
import action from '@flux/action';
// import _ from 'lodash';
import { produce } from 'immer';
import ClientCompany from './clientCompany';
import TargetCompany from './targetCompany';
import { formatCreateProjectDate } from '@utils/common';
import { SecondaryUseTips } from '@model/projects';
import { API } from '@service';
import _ from 'lodash';

const { Option } = Select;

const plainOptions = [
  {
    label: (
      <span>
        <span>Please reach out and provide our team a demo of the tool</span>
      </span>
    ),
    value: '1',
  },
  // {
  //   label: (
  //     <span>
  //       I would like to have someone from the M&A Gateway team reach out and
  //       &nbsp;
  //       <span style={{ fontWeight: 500 }}>help support this proposal</span>
  //     </span>
  //   ),
  //   value: '2',
  // },
  // {
  //   label: (
  //     <span>
  //       I want to use this project to pitch our digital capabilities or
  //       cross-sell products using M&A Gateway - please reach out and
  //       <span style={{ fontWeight: 500 }}>
  //         &nbsp;walk me through how I can tee this up to the client
  //       </span>
  //     </span>
  //   ),
  //   value: '3',
  // },
  {
    label: (
      <span>
        No support required - &nbsp;
        <span style={{ fontWeight: 500 }}>
          my team is familiar with M&A Gateway
        </span>
      </span>
    ),
    value: '4',
  },
  // {
  //   label: (
  //     <span>
  //       Just learning how the tool works -{' '}
  //       <span style={{ fontWeight: 500 }}>I’ll figure it out</span> and reach
  //       out if I have any questions
  //     </span>
  //   ),
  //   value: '5',
  // },
  {
    label: (
      <span>
        I would like to understand
        <span style={{ fontWeight: 500 }}>
          &nbsp;how to get product-related revenue credit
        </span>
      </span>
    ),
    value: '6',
  },
];

function ProjectsDetailForm(props) {
  const { theme } = useTheme();
  const isLightMode = theme === 'light';
  const liStyles = {
    position: 'absolute',
    left: 2,
    color: isLightMode ? '#2c2c2c' : '#DBDBDB',
    fontFamily: 'Helvetica Neue ,Arial',
    fontSize: '1rem',
  };
  const {
    queryCompanyName,
    queryCompanyResult,
    loading,
    settingProjectData,
    settingData,
    cRef,
  } = props;
  const { singleCompanyInstance, isSingleCompany } = useSelector(
    ({ common }) => common.projectCompanyInfo,
  );
  const handleChange = _.debounce((val, name, isLoading, mode) => {
    queryCompanyName(val, name, isLoading, mode);
  }, 1000);
  const [form] = Form.useForm();
  const subOneForm = useRef(null);
  const subTwoForm = useRef(null);
  const [projectTypes, setProjectTypes] = useState([]);

  const formData = produce(settingData, (draft) => {
    draft.anticipatedAnnouncementDate =
      draft.anticipatedAnnouncementDate &&
      moment(draft.anticipatedAnnouncementDate, 'YYYY/MM/DD');
    draft.targetDealCloseDate =
      draft.targetDealCloseDate &&
      moment(draft.targetDealCloseDate, 'YYYY/MM/DD');
    if (draft.isInternalUseOnly) {
      draft.projectName = draft.projectName.slice(13);
    } else {
      draft.projectName = draft.projectName.slice(8);
    }

    if (draft.buyerManualInputFlag !== true) {
      draft.buyerName = `${draft.buyerCompanyInfo?.name} ( DUNS : ${draft.buyerCompanyInfo?.duns} )`;
    }
    if (draft.targetManualInputFlag !== true) {
      draft.targetName = `${draft.targetCompanyInfo?.name} ( DUNS : ${draft.targetCompanyInfo?.duns} )`;
    }
    if (draft.buyerManualInputFlag === true) {
      draft.buyerName = '';
    }
    if (draft.targetManualInputFlag === true) {
      draft.targetName = '';
    }
    draft.theme = draft.theme === 'light';
    return draft;
  });
  // const handleChange = _.debounce((val, name, isLoading) => {
  //   queryCompanyName(val, name, isLoading);
  // }, 800);

  useImperativeHandle(cRef, () => ({
    getProjectForm: form,
    subOneRef: subOneForm.current,
    subTwoRef: subTwoForm.current,
  }));

  const initiateProjectTypes = async () => {
    const types = (await API.getAllProjectInstances()) || [];
    setProjectTypes(types);
  };

  useEffect(() => {
    form.setFieldsValue({
      ...formData,
      singleCompanyInstance: singleCompanyInstance || 'Integration',
    });
    initiateProjectTypes();
  }, []);
  useEffect(() => {
    // 当SaleForceOpportunity 是N/A时，清空 "Salesforce Opportunity ID" input的值
    if (settingData.isSalesforceOpportunityIDApplicable === false) {
      form.setFieldsValue({
        ...formData,
        salesforceOpportunityID: '',
      });
    }
  }, [settingData.isSalesforceOpportunityIDApplicable]);
  const onFinish = () => {
    if (settingData.buyerManualInputFlag) {
      settingProjectData({ currentNum: 2 });
    } else if (settingData.targetManualInputFlag) {
      settingProjectData({ currentNum: 3 });
    }
  };
  // useEffect(() => {
  //   console.log('saveData:', typeof settingData, JSON.stringify(settingData, null, 2));
  // }, [settingData]);

  return (
    <div className="projectDetail">
      {settingData.currentNum === 1 && (
        <Form
          onFinish={onFinish}
          name="createProject"
          form={form}
          layout="vertical"
          autoComplete="off"
        >
          <Row>
            <Col className="projectDetailLeft" span={11}>
              <div>
                <Form.Item
                  className="width-project-word-label"
                  label={
                    <div className="project-word-box">
                      Project Name
                      <Tooltip
                        title={`"Project"will be added before your Project Name automatically upon creation.`}
                      >
                        <span>
                          <span className="appkiticon icon-information-fill" />
                        </span>
                      </Tooltip>
                    </div>
                  }
                  name="projectName"
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: 'Project Name is required!',
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (
                          value?.toLocaleLowerCase()?.startsWith('project ')
                        ) {
                          return Promise.reject(
                            'Please remove "Project" from the name above as it will be added automatically upon creation.',
                          );
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                    }}
                  >
                    <div
                      className="label-from"
                      style={{ whiteSpace: 'nowrap', marginRight: '0.625rem' }}
                    >
                      {settingData.isInternalUseOnly
                        ? 'Project-Test'
                        : 'Project'}
                    </div>
                    <Input
                      defaultValue={
                        settingData.isInternalUseOnly
                          ? settingData.projectName.slice(13)
                          : settingData.projectName.slice(8)
                      }
                      maxLength={100}
                      onChange={async (e) => {
                        const val = e.target.value;
                        settingProjectData({
                          projectName:
                            (settingData.isInternalUseOnly
                              ? 'Project-Test '
                              : 'Project ') + val,
                        });
                        await form.setFieldsValue({
                          projectName: e.target.value,
                        });
                      }}
                    />
                  </div>
                </Form.Item>
                <Checkbox
                  style={{ marginBottom: '1.25rem' }}
                  checked={settingData.isInternalUseOnly}
                  onChange={async (e) => {
                    await settingProjectData({
                      ...settingData,
                      projectName:
                        (e.target.checked ? 'Project-Test ' : 'Project ') +
                        form.getFieldValue('projectName'),
                      isInternalUseOnly: e.target.checked,
                    });
                  }}
                >
                  <span className="checker-word label-from">
                    Test project for PwC internal use only
                  </span>
                </Checkbox>
              </div>

              <Form.Item
                label="Confidential"
                name="confidential"
                initialValue={settingData.conf}
                rules={[{ required: true, message: 'Option is required!' }]}
              >
                <Select
                  style={{
                    width: '18.75rem',
                    backgroundColor: '#2C2C2C',
                  }}
                  initialValue={settingData.confidential}
                  dropdownClassName="project-setting-select"
                  onChange={(v) => {
                    settingProjectData({
                      ...settingData,
                      confidential: v,
                    });
                  }}
                >
                  <Option value={true}>Yes</Option>
                  <Option value={false}>No</Option>
                </Select>
              </Form.Item>

              <Form.Item
                className="infoConfirmed"
                label={
                  <div>
                    <span>{SecondaryUseTips}</span>
                    <span className="required-star">*</span>
                  </div>
                }
                name="infoConfirmed"
                initialValue={settingData.secondaryUse}
              >
                <Select
                  style={{
                    width: 300,
                    backgroundColor: '#2C2C2C',
                  }}
                  dropdownClassName="project-setting-select"
                  onChange={(v) => {
                    settingProjectData({
                      ...settingData,
                      secondaryUse: v,
                    });
                  }}
                >
                  <Option value="Yes">Yes</Option>
                  <Option value="No">No</Option>
                  <Option value="unsure">I am not sure</Option>
                </Select>
              </Form.Item>
              {/* <Form.Item name="isSingleCompany">
                <Checkbox
                  // options={plainOptions}
                  checked={settingData.isSingleCompany}
                  disabled
                />{' '}
                Single Company
              </Form.Item> */}
              {isSingleCompany && (
                <div className="create-project-radio-group">
                  <Form.Item name="singleCompanyInstance">
                    <Radio.Group>
                      <Radio value="Integration" disabled>
                        Integration
                      </Radio>
                      <Radio value="Divestiture" disabled>
                        Divestiture / Separation
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
              )}

              <Form.Item
                label="Project Type"
                name="companyInstance"
                className="company-instance-switch-wrapper"
                initialValue={settingData.companyInstance}
                rules={[{ required: true, message: 'Option is required!' }]}
              >
                <Select
                  style={{
                    width: 300,
                    backgroundColor: '#2C2C2C',
                  }}
                  disabled={true}
                  defaultValue={
                    settingData.companyInstance ||
                    (projectTypes[0] || {}).id ||
                    null
                  }
                  dropdownClassName="project-setting-select"
                  onChange={(v) => {
                    settingProjectData({
                      companyInstance: v,
                    });
                  }}
                >
                  {projectTypes.map((e, i) => (
                    <Option value={e.id} key={`${i}-${e.id}`}>
                      {e.instanceName}
                    </Option>
                  ))}
                  {/* <Option value={'Integration'}>Buy-Side</Option>
                  <Option value={'Divestiture'}>Sell-Side</Option> */}
                </Select>
              </Form.Item>

              <div style={{ display: 'flex', flexFlow: 'column' }}>
                <div
                  className="project-form-wrapper"
                  // style={{
                  //   order:
                  //     settingData.companyInstance === 'Integration' ? 1 : 3,
                  // }}
                >
                  <Form.Item
                    name="buyerCheckerName"
                    className="checker"
                    // style={{ display: 'none' }}
                  >
                    <Checkbox
                      checked={Boolean(settingData.buyerManualInputFlag)}
                      disabled
                      onChange={(e) => {
                        settingProjectData({
                          buyerManualInputFlag: e.target.checked,
                        });
                        form.setFieldsValue({ buyerName: '' });
                      }}
                    >
                      <span className="checker-word">Not Available</span>
                    </Checkbox>
                  </Form.Item>

                  {settingData.buyerManualInputFlag &&
                  !form.getFieldValue('focusOnA') ? (
                    <div className="not-available setting-not-available">
                      Not Available
                    </div>
                  ) : null}
                  <Form.Item
                    label="Company A Name"
                    name="buyerName"
                    rules={[
                      {
                        required: !settingData.buyerManualInputFlag,
                        whitespace: true,
                        message: `Company A Name is required!`,
                      },
                    ]}
                  >
                    <Select
                      className="select"
                      dropdownClassName="down-box"
                      showSearch
                      // disabled={Boolean(settingData.buyerManualInputFlag)}
                      // disabled
                      disabled={Boolean(form.getFieldValue('buyerName'))}
                      filterOption={false}
                      // open={true}
                      notFoundContent={
                        loading ? (
                          <Spin size="small" style={{ marginLeft: '48%' }} />
                        ) : null
                      }
                      onFocus={(e) => {
                        form.setFieldsValue({
                          buyerCheckerName: false,
                          focusOnA: true,
                        });
                        if (form.getFieldValue('targetName')) {
                          form.validateFields(['targetName']);
                        }
                        settingProjectData({
                          ...settingData,
                          // buyerManualInputFlag: false,
                          // buyerCompanyInfo: {
                          //   isFromDuns: false,
                          // },
                        });
                      }}
                      onSearch={(e) => {
                        e && handleChange(e, 'buyerName', true, 'name');
                      }}
                      onChange={(e, attrs) => {
                        form.setFieldsValue({ buyerCheckerName: false });
                        settingProjectData({
                          ...settingData,
                          buyerManualInputFlag: false,
                          buyerName: attrs['company-name'],
                          buyerCraftId: attrs['craft-id'],
                          buyerDuns: attrs['buyer-duns'],
                          buyerCompanyInfo: {
                            name: attrs['company-name'],
                            duns: attrs['target-duns'],
                            parentCompany: null,
                            companyWebsite: null,
                            description: null,
                            industry: null,
                            headquarters: null,
                            incorporationDate: null,
                            employeeHeadcount: null,
                            estimatedTotalRevenue: null,
                            estimatedMarketCap: null,
                          },
                        });
                        if (form.getFieldValue('targetName')) {
                          form.validateFields(['targetName']);
                        }
                      }}
                      onBlur={() => {
                        settingProjectData({
                          ...settingData,
                        });
                        form.setFieldsValue({
                          focusOnA: false,
                        });
                      }}
                    >
                      {!loading &&
                        Array.isArray(queryCompanyResult.buyerName) &&
                        queryCompanyResult.buyerName.map(
                          (item) =>
                            item.displayName && (
                              <Option
                                value={`${item.displayName} (DUNS : ${item.duns})`}
                                craft-id={item.craftId}
                                buyer-duns={item.duns}
                                company-name={item.displayName}
                                key={item.duns}
                                item={item}
                              >
                                <ul style={{ position: 'relative' }}>
                                  <li style={liStyles}>
                                    {`${item.displayName} (DUNS : ${item.duns})`}
                                  </li>
                                </ul>
                              </Option>
                            ),
                        )}
                    </Select>
                  </Form.Item>
                </div>

                <Form.Item label="Rename Company A Label" name="buyerLabel">
                  <Input
                    maxLength={15}
                    placeholder={
                      settingData.companyInstance === 'Integration'
                        ? 'Buyer'
                        : 'RemainCo'
                    }
                    onChange={(ele) => {
                      settingProjectData({
                        buyerLabel: ele.target.value,
                      });
                    }}
                  />
                </Form.Item>

                {!settingData.isSingleCompany && (
                  <div className="project-form-wrapper">
                    <Form.Item name="targetCheckerName" className="checker">
                      <Checkbox
                        // style={{ display: 'none' }}
                        checked={Boolean(settingData.targetManualInputFlag)}
                        disabled
                        onChange={(e) => {
                          settingProjectData({
                            targetManualInputFlag: e.target.checked,
                          });
                          form.setFieldsValue({ targetName: '' });
                        }}
                      >
                        <span className="checker-word">Not Available</span>
                      </Checkbox>
                    </Form.Item>
                    {settingData.targetManualInputFlag &&
                    !form.getFieldValue('focusOnB') ? (
                      <div className="not-available setting-not-available">
                        Not Available
                      </div>
                    ) : null}
                    <Form.Item
                      label="Company B Name"
                      name="targetName"
                      rules={[
                        {
                          required: !settingData.targetManualInputFlag,
                          whitespace: true,
                          message: 'Company B Name is required!',
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const buyerName = getFieldValue(
                              'buyerName',
                            )?.replace(/\s/g, '');
                            const currentValue = value?.replace(/\s/g, '');
                            if (!value || buyerName !== currentValue) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              'Company B Name can not be the same as Company A Name!',
                            );
                          },
                        }),
                      ]}
                    >
                      <Select
                        className="select"
                        dropdownClassName="down-box"
                        showSearch
                        // disabled={Boolean(settingData.targetManualInputFlag)}
                        // disabled
                        disabled={Boolean(form.getFieldValue('targetName'))}
                        filterOption={false}
                        notFoundContent={
                          loading ? (
                            <Spin size="small" style={{ marginLeft: '48%' }} />
                          ) : null
                        }
                        onFocus={(e) => {
                          form.setFieldsValue({
                            // targetName: '',
                            targetCheckerName: false,
                            focusOnB: true,
                          });

                          if (form.getFieldValue('buyerName')) {
                            form.validateFields(['buyerName']);
                          }
                          settingProjectData({
                            ...settingData,
                            // targetManualInputFlag: false,
                            // targetCompanyInfo: {
                            //   isFromDuns: false,
                            // },
                          });
                        }}
                        onSearch={(e) => {
                          e && handleChange(e, 'targetName', true, 'name');
                        }}
                        onChange={(e, attrs) => {
                          form.setFieldsValue({ targetCheckerName: false });
                          settingProjectData({
                            ...settingData,
                            targetManualInputFlag: false,
                            targetName: attrs['company-name'],
                            targetCraftId: attrs['craft-id'],
                            targetDuns: attrs['target-duns'],
                            targetCompanyInfo: {
                              name: attrs['company-name'],
                              duns: attrs['target-duns'],
                              parentCompany: null,
                              companyWebsite: null,
                              description: null,
                              industry: null,
                              headquarters: null,
                              incorporationDate: null,
                              employeeHeadcount: null,
                              estimatedTotalRevenue: null,
                              estimatedMarketCap: null,
                            },
                          });
                          if (form.getFieldValue('buyerName')) {
                            form.validateFields(['buyerName']);
                          }
                        }}
                        onBlur={() => {
                          settingProjectData({
                            ...settingData,
                          });
                          form.setFieldsValue({
                            focusOnB: false,
                          });
                        }}
                      >
                        {!loading &&
                          Array.isArray(queryCompanyResult.targetName) &&
                          queryCompanyResult.targetName.map(
                            (item) =>
                              item.displayName && (
                                <Option
                                  value={`${item.displayName} (DUNS : ${item.duns})`}
                                  craft-id={item.craftId}
                                  target-duns={item.duns}
                                  company-name={item.displayName}
                                  key={item.duns}
                                  item={item}
                                >
                                  <ul style={{ position: 'relative' }}>
                                    <li style={liStyles}>
                                      {`${item.displayName} (DUNS : ${item.duns})`}
                                    </li>
                                  </ul>
                                </Option>
                              ),
                          )}
                      </Select>
                    </Form.Item>
                  </div>
                )}

                <Form.Item
                  label="Rename Company B Label"
                  name="targetLabel"
                  // style={{
                  //   order:
                  //     settingData.companyInstance === 'Integration' ? 4 : 2,
                  // }}
                >
                  <Input
                    maxLength={15}
                    placeholder={
                      settingData.companyInstance === 'Integration'
                        ? 'Target'
                        : 'Buyer'
                    }
                    onChange={(ele) => {
                      settingProjectData({
                        targetLabel: ele.target.value,
                      });
                    }}
                  />
                </Form.Item>
              </div>

              <Form.Item
                label="Anticipated Announcement Date"
                name="anticipatedAnnouncementDate"
              >
                <DatePicker
                  format="MM/DD/YY"
                  onChange={(date, dateStr) => {
                    settingProjectData({
                      ...settingData,
                      // anticipatedAnnouncementDate:dateStr
                      anticipatedAnnouncementDate: date
                        ? formatCreateProjectDate(
                            date.years(),
                            date.month() + 1,
                            date.date(),
                          )
                        : null,
                    });
                  }}
                />
              </Form.Item>
              <Form.Item
                label="Target Deal Close Date"
                name="targetDealCloseDate"
                // rules={[
                //   {
                //     required: true,
                //     message: `Target Deal Close Date is required!`,
                //   },
                // ]}
              >
                <DatePicker
                  format="MM/DD/YY"
                  onChange={(date, dateStr) => {
                    settingProjectData({
                      ...settingData,
                      // targetDealCloseDate:dateStr
                      targetDealCloseDate: date
                        ? formatCreateProjectDate(
                            date.years(),
                            date.month() + 1,
                            date.date(),
                          )
                        : null,
                    });
                  }}
                />
              </Form.Item>
            </Col>

            <Col span={2} />
            <Col className="projectDetailRight" span={11}>
              <Form.Item
                label="What is the stage of your engagement opportunity?"
                name="stageLabel"
              >
                <Select
                  defaultValue={
                    settingData.engagementOpportunity
                      ? settingData.engagementOpportunity
                      : 'Select the stage'
                  }
                  className="select"
                  // dropdownClassName="down-box"
                  dropdownClassName="project-setting-select"
                  onChange={async (value) => {
                    await settingProjectData({
                      ...settingData,
                      engagementOpportunity: value,
                    });
                  }}
                >
                  <Option value="Select the stage">Select the stage</Option>
                  <Option value="Pre-RFP">Pre-RFP</Option>
                  <Option value="Proposal / RFP">Proposal / RFP</Option>
                  <Option value="Signed Engagement / SOW">
                    Signed Engagement / SOW
                  </Option>
                  <Option value="Other">Other</Option>
                </Select>
              </Form.Item>

              <Form.Item
                className="salesforce-opportunity-id"
                label={
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      width: '100%',
                    }}
                  >
                    <div>Salesforce Opportunity ID</div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <span
                        style={{
                          marginRight: '0.313rem',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Not Applicable
                      </span>
                      <Checkbox
                        style={{ marginBottom: '0.625rem' }}
                        checked={
                          settingData.isSalesforceOpportunityIDApplicable ===
                          false
                        }
                        onChange={async (e) => {
                          await settingProjectData({
                            ...settingData,
                            isSalesforceOpportunityIDApplicable:
                              !e.target.checked,
                            salesforceOpportunityID: null,
                          });
                        }}
                      />
                    </div>
                  </div>
                }
                name="salesforceOpportunityID"
              >
                <Input
                  maxLength={15}
                  disabled={
                    settingData.isSalesforceOpportunityIDApplicable === false
                  }
                  placeholder="Sample: 1054l00000zBHN1DAL"
                  onChange={(e) => {
                    settingProjectData({
                      ...settingData,
                      salesforceOpportunityID: e.target.value,
                    });
                  }}
                />
              </Form.Item>

              <Form.Item
                label="Did we win the engagement?"
                name="winTheEngagement"
                initialValue={settingData.winTheEngagement}
                rules={[{ required: true, message: 'Option is required!' }]}
              >
                <Select
                  style={{
                    width: 300,
                    backgroundColor: '#2C2C2C',
                  }}
                  dropdownClassName="project-setting-select"
                  onChange={(v) => {
                    settingProjectData({
                      ...settingData,
                      winTheEngagement: v,
                    });
                  }}
                >
                  <Option value="Yes">Yes</Option>
                  <Option value="No">No</Option>
                  <Option value="not applicable">Not Applicable</Option>
                </Select>
              </Form.Item>
              <div className="check-group-title">
                Supplemental Requests (Select all that apply){' '}
                {/* <span className="title-text-14">[Select all that apply]</span> */}
              </div>
              <Form.Item name="supplementalRequests">
                <Checkbox.Group
                  options={plainOptions}
                  disabled
                  onChange={(arr) => {
                    settingProjectData({
                      ...settingData,
                      supplementalRequests: arr,
                    });
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <div className="form-actions-wrapper">
            {(Boolean(settingData.buyerManualInputFlag) ||
              Boolean(settingData.targetManualInputFlag)) && (
              <Button className="ok-btn" htmlType="submit">
                next
              </Button>
            )}
          </div>
        </Form>
      )}
      {settingData.currentNum === 2 && <ClientCompany cRef={subOneForm} />}
      {settingData.currentNum === 3 && <TargetCompany cRef={subTwoForm} />}
    </div>
  );
}

const mapStateToProps = ({ projects }) => ({
  queryCompanyResult: projects.queryCompanyResult || {},
  loading: projects.queryCompanyLoading,
  settingData: projects.settingData,
});

const mapDispatchToProps = (dispatch) => ({
  queryCompanyName(word, type, isLoading, mode) {
    dispatch(action.queryCompanyName(word, type, isLoading, mode));
  },
  settingProjectData(word, type) {
    dispatch(action.settingProjectData(word, type));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(ProjectsDetailForm));
